import { useGetShiftHandoverDashboardQuery } from "app/services/api/shiftHandoverApi";

export function useHandleShiftHandoverDashboard({
  roomIds,
  floorIds,
  unassigned,
}: {
  roomIds?: number[];
  floorIds?: number[];
  unassigned?: boolean;
} = {}) {
  const filter: Record<string, number[] | boolean> = {};

  if (roomIds?.length) filter.room_id = roomIds;
  if (floorIds?.length) filter.floor_id = floorIds;
  if (unassigned) filter.unassigned = true;

  const { data, isLoading, refetch } = useGetShiftHandoverDashboardQuery(
    Object.keys(filter).length ? { filter } : undefined,
  );

  return { data, isLoading, refetch };
}
